import en from './en.json';
import de from './de.json';

const modules = { en, de };

module.exports = modules;
